import { AlertColor } from "@mui/material";


export const isBrowserViewable = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    return ['pdf', 'txt', 'html', 'htm', 'xml', 'json', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'mp4', 'webm', 'ogg', 'mp3', 'wav', 'css', 'js', 'md'].includes(extension ?? '');
};

export const openAttachmentUtils = async (
    attachmentId: number | string,
    attachmentSize: string,
    attachmentName: string,
    isDraft: boolean,
    displaySnackbar: (severity: AlertColor, content: React.ReactNode) => void,
    token: string,
    draftId?: number,
    download?: boolean
) => {
    let popup: Window | null = null;
    try {
        const apibaseurl = process.env.REACT_APP_API_URL;
        const isViewable = isBrowserViewable(attachmentName);
        const isLarge = attachmentSize && parseInt(attachmentSize.replaceAll(',', '')) > 100000;

        if (isLarge) {
            displaySnackbar("warning", "Large file download in progress. This might take a few minutes.");
        }

        const url = isDraft
            ? `${apibaseurl}/api/v3/drafts/workitems/${draftId}/attachments/${attachmentId}/download`
            : `${apibaseurl}/api/v3/attachments/${attachmentId}/download`;

        if (isViewable && !download) {
            popup = window.open('', '_blank');
            if (popup) {
                popup.document.write(`<html>
              <head>
                <title>Loading File...</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                    color: #555;
                }
                .spinner {
                    border: 2px solid #f3f3f3;
                    border-top: 2px solid #1976d2;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    animation: spin 1s linear infinite;
                    margin: 0 auto 20px auto;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .content {
                    text-align: center;
                }
                </style>
              </head>
              <body>
                <div>
                  <div class="spinner"></div>
                  <h5>Loading your file...</h5>
                </div>
              </body>
            </html>`);
            }
        }

        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (!response.ok) {
            displaySnackbar('error', 'Failed to fetch attachment');
            // toggleAttachmentLink(attachmentId.toString(), false);
            if (popup) popup.close();
            return;
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        if (isViewable && !download) {
            if (popup) {
                popup.location.href = blobUrl;
                popup.document.close();
            } else {
                console.log('drawer opened');
            }
        } else {
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = attachmentName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('Error opening attachment', error);
        displaySnackbar('error', 'Error opening attachment');
        if (popup) popup.close();
    }
};

// Example of how to detect pop-up blocked in case it is needed on the future
// Attempts to open a URL in a new tab. Detects popup block and notifies the global handler.
// export function safeWindowOpen(url: string, target: string = "_blank") {
//     const newWindow = window.open(url, target);

//     if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
//         showPopupBlockedAlert();
//     }

//     return newWindow;
// }